import Vue from 'vue';
import Router from 'vue-router';
import jwtDecode from 'jwt-decode';
import { appIsActive } from './config';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      component: () => import(/* webpackChunkName: "landing-page" */ './views/LandingPage.vue'),
      beforeEnter: (to, from, next) => {
        let token = localStorage.getItem('token');
        if (!token || from.path.startsWith('/app')) return next();

        let decoded = jwtDecode(token);
        if (!decoded) return next();

        return next('/app');
      },
    },
    {
      path: '/app',
      component: () => import(/* webpackChunkName: "user-app" */ './views/user-app/UserApp.vue'),
      beforeEnter: (to, from, next) => {
        let token = localStorage.getItem('token');
        if (!token) return next('/');

        let decoded = jwtDecode(token);
        if (!decoded) return next('/');

        return next();
      },
      children: [
        ...(appIsActive
          ? [
              {
                path: '',
                component: () => import(/* webpackChunkName: "user-app" */ './views/user-app/subviews/UserHome.vue'),
              },
              {
                path: 'schedule',
                name: 'app-schedule',
                component: () =>
                  import(/* webpackChunkName: "user-app" */ './views/user-app/subviews/UserSchedule.vue'),
              },
              {
                path: 'prizes',
                component: () => import(/* webpackChunkName: "user-app" */ './views/user-app/subviews/UserPrizes.vue'),
              },
              {
                path: 'map',
                name: 'app-map',
                component: () => import(/* webpackChunkName: "user-app" */ './views/user-app/subviews/UserMap.vue'),
              },
              {
                path: 'fly-talks',
                component: () =>
                  import(/* webpackChunkName: "user-app" */ './views/user-app/subviews/UserFlyTalks.vue'),
              },
              {
                path: 'profile',
                component: () => import(/* webpackChunkName: "user-app" */ './views/user-app/subviews/UserProfile.vue'),
              },
            ]
          : [
              {
                path: '',
                component: () => import(/* webpackChunkName: "user-app" */ './views/user-app/subviews/UserProfile.vue'),
              },
            ]),
      ],
    },
    {
      path: '/admin',
      component: () => import(/* webpackChunkName: "admin" */ './views/admin/Admin.vue'),
      beforeEnter: (to, from, next) => {
        let token = localStorage.getItem('token');
        if (!token) return next('/');

        let decoded = jwtDecode(token);
        if (!decoded) return next('/');

        if (decoded.roles === 'Administrator') return next();

        return next('/');
      },
      children: [
        {
          path: '',
          component: () => import(/* webpackChunkName: "admin" */ './views/admin/subviews/Welcome.vue'),
        },
        {
          path: 'users',
          component: () => import(/* webpackChunkName: "admin" */ './views/admin/subviews/ManageUsers.vue'),
        },
        {
          path: 'companies',
          component: () => import(/* webpackChunkName: "admin" */ './views/admin/subviews/ManageCompanies.vue'),
        },
        {
          path: 'events',
          component: () => import(/* webpackChunkName: "admin" */ './views/admin/subviews/ManageEvents.vue'),
        },
        {
          path: 'venues',
          component: () => import(/* webpackChunkName: "admin" */ './views/admin/subviews/ManageVenues.vue'),
        },
        {
          path: 'achievements',
          component: () => import(/* webpackChunkName: "admin" */ './views/admin/subviews/ManageAchievements.vue'),
        },
        {
          path: 'achievement-codes',
          component: () => import(/* webpackChunkName: "admin" */ './views/admin/subviews/ManageAchievementCodes.vue'),
        },
        {
          path: 'survey-questions',
          component: () => import(/* webpackChunkName: "admin" */ './views/admin/subviews/ManageSurveyQuestions.vue'),
        },
        {
          path: 'jobs',
          component: () => import(/* webpackChunkName: "admin" */ './views/admin/subviews/ManageJobs.vue'),
        },
        {
          path: 'arrival-time-slots',
          component: () => import(/* webChunkName: "admin" */ './views/admin/subviews/ManageArrivalTimeSlots.vue'),
        },
        {
          path: 'features',
          component: () => import(/* webpackChunkName: "admin" */ './views/admin/subviews/ManageFeatures.vue'),
        },
        {
          path: 'configuration',
          component: () => import(/* webpackChunkName: "admin" */ './views/admin/subviews/ManageConfiguration.vue'),
        },
        {
          path: 'newsboard',
          component: () => import(/* webpackChunkName: "admin" */ './views/admin/subviews/ManageNewsboard.vue'),
        },
      ],
    },
    {
      path: '/activate',
      component: () => import(/* webpackChunkName: "activate" */ './views/Activate.vue'),
    },
    {
      path: '/reset',
      component: () => import(/* webpackChunkName: "reset" */ './views/Reset.vue'),
    },
    {
      path: '*',
      component: () => import(/* webpackChunkName: "notfound" */ './views/NotFound.vue'),
    },
  ],
});
